/** Stockage session démo (onglet). Révoqué à la fermeture du navigateur. */
export const DEMO_TOKEN_KEY = "epp_demo_access_token";
/** Référence prospect (`?lead=` / `?lead_ref=`) — réutilisée pour le suivi commercial. */
export const DEMO_LEAD_REF_KEY = "epp_demo_lead_ref";

export function readDemoToken() {
  try {
    return sessionStorage.getItem(DEMO_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function writeDemoToken(token) {
  try {
    if (token) sessionStorage.setItem(DEMO_TOKEN_KEY, token);
    else sessionStorage.removeItem(DEMO_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

const LEAD_REF_MAX = 64;
const LEAD_REF_OK = /^[a-zA-Z0-9._-]{1,64}$/;

export function normalizeLeadRef(raw) {
  if (raw == null || String(raw).trim() === "") return null;
  const s = String(raw).trim().slice(0, LEAD_REF_MAX);
  return LEAD_REF_OK.test(s) ? s : null;
}

/** Lit la référence prospect mémorisée (session). */
export function readDemoLeadRef() {
  try {
    const v = sessionStorage.getItem(DEMO_LEAD_REF_KEY);
    return normalizeLeadRef(v);
  } catch {
    return null;
  }
}

export function writeDemoLeadRef(ref) {
  try {
    const n = normalizeLeadRef(ref);
    if (n) sessionStorage.setItem(DEMO_LEAD_REF_KEY, n);
    else sessionStorage.removeItem(DEMO_LEAD_REF_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Extrait `lead` ou `lead_ref` depuis une chaîne de requête (ex. location.search).
 * À appeler sur /demo ou à l’entrée vitrine.
 */
export function leadRefFromSearch(search) {
  if (!search || typeof search !== "string") return null;
  const q = new URLSearchParams(search.startsWith("?") ? search : `?${search}`);
  return normalizeLeadRef(q.get("lead_ref") || q.get("lead"));
}

/** En-têtes à fusionner sur les appels API lorsque la session démo est active. */
export function demoHeadersExtra() {
  const t = readDemoToken();
  return t ? { "X-Demo-Session": `Bearer ${t}` } : {};
}
